// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--3JEHr","dropdown_content":"index-module--dropdown_content--iTDcT","phone":"index-module--phone--s0j2Y"};